import { Box, Tooltip } from '@chakra-ui/react';
import { transparentize } from '@chakra-ui/theme-tools';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';

import { IRiskAction, IRiskIcon, RiskMessage } from './types';

export const RiskIcon = (props: IRiskAction) => {
  const { isCheckedOff, isDoc, isDocumentFixed, boxProps } = props;

  const getIconProps = (): IRiskIcon => {
    if (isCheckedOff) {
      return {
        label: RiskMessage.ACKNOWLEDGED,
        icon: faFileMagnifyingGlass,
        colorScheme: 'gray',
      };
    }

    if (isDoc) {
      if (isDocumentFixed) {
        return {
          label: RiskMessage.REUPLOADED,
          icon: faFileMagnifyingGlass,
          colorScheme: 'gray',
        };
      }
      return {
        label: RiskMessage.ACTIONREQUIRED,
        icon: faFileMagnifyingGlass,
        colorScheme: 'orange',
      };
    }

    return {
      label: RiskMessage.RISK,
      icon: faFileMagnifyingGlass,
      colorScheme: 'orange',
    };
  };

  const { label, colorScheme, icon } = getIconProps();

  return (
    <Box
      as="span"
      ml={boxProps?.ml}
      color={`${colorScheme}.400`}
      _dark={{ color: transparentize(`${colorScheme}.400`, 0.67) }}
    >
      <Tooltip placement="top" label={label} hasArrow>
        <FontAwesomeIcon icon={icon} className="indicator-icon" />
      </Tooltip>
    </Box>
  );
};
